/* Small inline icon set (stroke-based, inherit currentColor). */
type P = { size?: number };
const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.9,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
});

export const IconPlug = ({ size = 22 }: P) => (
  <svg {...base(size)}><path d="M9 2v6M15 2v6M7 8h10v3a5 5 0 0 1-10 0V8ZM12 16v6" /></svg>
);
export const IconWindow = ({ size = 22 }: P) => (
  <svg {...base(size)}><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 9h18M7 6.5h.01M10 6.5h.01" /></svg>
);
export const IconBolt = ({ size = 22 }: P) => (
  <svg {...base(size)}><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" /></svg>
);
export const IconCompass = ({ size = 22 }: P) => (
  <svg {...base(size)}><circle cx="12" cy="12" r="9" /><path d="m15.5 8.5-2 5-5 2 2-5 5-2Z" /></svg>
);
export const IconCheck = ({ size = 18 }: P) => (
  <svg {...base(size)}><path d="m20 6-11 11-5-5" /></svg>
);
export const IconArrow = ({ size = 17 }: P) => (
  <svg {...base(size)} className="arrow"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);
export const IconMenu = ({ size = 24 }: P) => (
  <svg {...base(size)}><path d="M4 7h16M4 12h16M4 17h16" /></svg>
);
export const IconClose = ({ size = 24 }: P) => (
  <svg {...base(size)}><path d="M6 6l12 12M18 6 6 18" /></svg>
);
